import { gql } from '@apollo/client';

export const GET_PROPERTY_REDIRECT_QUERY = gql`
  query GetPropertyRedirect($input: PropertyInput) {
    getProperty(input: $input) {
      id
      office {
        info {
          id
          urltag
        }
      }
      permalink
    }
  }
`;
